import { useState } from 'react';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { ButtonV3Props } from '@zola/zola-ui/src/components/ButtonV3/ButtonV3';

import { getLastInquiryToStorefront } from '~/components/common/ui/inquiries/useLastInquiryToStorefront';
import { getStorefrontDetails } from '~/libs/client/api/storefronts';
import { useInquiryModal } from '~/pages/couples/inquiry-flow/showInquiryModal';
import { useAppDispatch, useAppSelector } from '~/reducers';
import { StandardLogFn } from '~/util/logger';
import { TrackingProductLocation } from '~/util/trackingHelper';

interface InquiryButtonProps {
  storefrontUuid: string;
  firstMoveUuid?: string;
  slug: string | null;
  className?: string;
  reopenSourceModal?: () => void;
  hideModalFn?: () => void;
  variant?: ButtonV3Props['variant'];
  trackingLocation?: TrackingProductLocation;
}

/**
 * An inquiry button that first loads the storefront details before showing the inquiry modal.
 *
 * @param param0
 * @returns
 */
const InquiryButton = ({
  storefrontUuid,
  firstMoveUuid,
  slug,
  className,
  reopenSourceModal,
  hideModalFn,
  variant,
  trackingLocation = TrackingProductLocation.QUICK_VIEW,
}: InquiryButtonProps) => {
  const dispatch = useAppDispatch();
  const { showInquiryModal } = useInquiryModal();
  const [loading, setLoading] = useState(false);

  const lastInquiry = useAppSelector(getLastInquiryToStorefront(storefrontUuid));

  const onClick = (e: React.SyntheticEvent<EventTarget>) => {
    if (!slug) return;

    e.preventDefault();

    if (lastInquiry) {
      window.location.assign(`/wedding-vendors/inquiries/${lastInquiry.uuid}`);
      if (hideModalFn) hideModalFn();
    } else {
      setLoading(true);
      getStorefrontDetails(slug)
        .then((storefront) => {
          showInquiryModal({
            dispatch,
            trackingLocation,
            storefront,
            firstMoveUuid,
            reopenSourceModal,
          });
        })
        .catch(StandardLogFn)
        .finally(() => setLoading(false));
    }
  };

  return (
    <ButtonV3
      onClick={onClick}
      disabled={loading}
      fullWidth
      className={className}
      variant={variant}
    >
      {lastInquiry ? 'View Messages' : 'Get a quote'}
    </ButtonV3>
  );
};

export default InquiryButton;
